import React from 'react';
var PreviewerActionsExtra = function PreviewerActionsExtra() {
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};
export default PreviewerActionsExtra;